(function () {
  var css = ":host,:host *{font-family:'Work Sans','Helvetica Neue',Arial,sans-serif}"
    + "div[class*='formContainer']{min-height:0 !important;overflow:visible !important}"
    + ":host h1,:host h2,:host h3,:host [class*='title'],:host [class*='Title']{font-family:'EB Garamond',Garamond,Georgia,serif !important;font-weight:500 !important;color:#18566C !important;font-size:31px !important;line-height:1.15 !important;letter-spacing:0 !important}"
    + ":host p{color:#4E7D91 !important;font-size:14.5px !important;line-height:1.62 !important}"
    + ":host input{box-sizing:border-box !important;font-size:16px !important;color:#052C46 !important;background:#FCF7FA !important;border:1px solid rgba(24,86,108,0.15) !important;border-radius:10px !important;box-shadow:none !important}"
    + ":host input::placeholder{color:#9DB0B9 !important}"
    + ":host input:focus{outline:none !important;background:#ffffff !important;border-color:#5B79C4 !important;box-shadow:0 0 0 3px rgba(91,121,196,0.2) !important}"
    + ":host button{box-sizing:border-box !important;padding:15px 20px !important;font-size:15.5px !important;font-weight:600 !important;color:#FCF7FA !important;background:#18566C !important;border:0 !important;border-radius:10px !important;cursor:pointer !important;min-height:0 !important;line-height:1.2 !important}"
    + ":host button:hover{background:#12455A !important}"
    + ":host a{color:#18566C !important;text-underline-offset:2px !important}";
  function inject(root) {
    if (!root) return;
    if (root.querySelector("style[data-studio]")) return;
    var s = document.createElement("style");
    s.setAttribute("data-studio", "1");
    s.textContent = css;
    root.appendChild(s);
  }
  function scan() {
    var host = document.querySelector(".studio-signup");
    if (!host) return;
    var all = host.querySelectorAll("*");
    for (var i = 0; i < all.length; i++) {
      if (all[i].shadowRoot) inject(all[i].shadowRoot);
    }
  }
  scan();
  var n = 0;
  var timer = setInterval(function () {
    scan();
    n = n + 1;
    if (n > 60) clearInterval(timer);
  }, 200);
})();
